import React from 'react';
import { InvestmentStatus, Investments } from '../redux/types';
// import { getInterestRate } from '../utils';
// import { dealTypes } from '../../../login/utils/Status';
import { Empty, Spin } from 'antd';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import HSTable from '../../../common/HSTable';
import { commaSeperator } from '../../../utils/validation';
import { Amount } from '../../deals/redux/types';

type Props = {
    loading: boolean;
    investments: Investments[];
};

const InvestmentTable: React.FC<Props> = ({ loading, investments }) => {
    const navigate = useNavigate();

    const columns = [
        {
            title: 'Issuer',
            dataIndex: 'issuerName',
            fixed: 'left',
            width: 200,
            render: (text: string) => <span>{text || '-'}</span>,
        },
        {
            title: 'Deal',
            dataIndex: 'dealName',
            width: 200,
            fixed: 'left',
            render: (text: string) => <span>{text}</span>,
        },
        {
            title: 'Deal Type',
            dataIndex: 'dealType',
            fixed: 'left',
            width: 100,
            render: (text?: string) => <span>{text}</span>,
        },
        {
            title: 'Instrument Type',
            dataIndex: 'instrumentType',
            width: 200,
            render: (text: string) => <span>{text || '-'}</span>,
        },
        {
            title: 'Investment Amount',
            width: 200,
            render: (record: Amount) => (
                <span>
                    {record &&
                        record.amountUpto2dp &&
                        `${record.currency} ${commaSeperator(
                            parseFloat(String(record.amountUpto2dp || 0)).toFixed(2),
                        )}`}
                </span>
            ),
            sorter: (a: Investments, b: Investments) =>
                (a.investmentAmount?.amountUpto2dp || 0) - (b.investmentAmount?.amountUpto2dp || 0),
            dataIndex: 'investmentAmount',
        },
        {
            title: 'Investment Date',
            width: 150,
            dataIndex: 'investmentDate',
            render: (record?: string) => <span>{record ? moment(record).format('DD-MMM-YY') : 'NA'}</span>,
            sorter: (a: Investments, b: Investments) =>
                moment(a.investmentDate || '').unix() - moment(b.investmentDate || '').unix(),
        },
        {
            title: 'Maturity Date',
            width: 150,
            dataIndex: 'maturityDate',
            render: (record?: string) => <span>{record ? moment(record).format('DD-MMM-YY') : 'NA'}</span>,
            sorter: (a: Investments, b: Investments) => moment(a.maturityDate).unix() - moment(b.maturityDate).unix(),
        },
        {
            title: 'Outstanding Principal',
            width: 160,
            dataIndex: 'outstandingPrincipal',
            render: (record?: Amount) => (
                <span>
                    {record?.amountUpto2dp
                        ? `${record.currency} ${commaSeperator(
                              parseFloat(String(record.amountUpto2dp || 0)).toFixed(2),
                          )}`
                        : 'NA'}
                </span>
            ),
            sorter: (a: Investments, b: Investments) =>
                (a.derived?.outstandingPrincipal?.amountUpto2dp || 0) -
                (b.derived?.outstandingPrincipal?.amountUpto2dp || 0),
        },
        {
            title: 'Interest Rate (p.a.)',
            width: 200,
            dataIndex: 'interestRate',
            render: (text?: string) => (
                <span>
                    {/* {(dealTypes.equity !== record.dealType &&
                        record.investmentAmount &&
                        getInterestRate(record.investmentAmount.currency, record)) ||
                        '-'} */}
                    {text ? `${text}` : 'NA'}
                </span>
            ),
        },
        {
            title: 'Total Distribution/Interest Paid To Date',
            width: 150,
            dataIndex: 'totalDistribution',
            render: (record?: Amount) => (
                <span>
                    {record?.amountUpto2dp
                        ? `${record.currency} ${commaSeperator(
                              parseFloat(String(record.amountUpto2dp || 0)).toFixed(2),
                          )}`
                        : 'NA'}
                </span>
            ),
            sorter: (a: Investments, b: Investments) =>
                (a.derived?.totalDistribution?.amountUpto2dp || 0) - (b.derived?.totalDistribution?.amountUpto2dp || 0),
        },
        {
            title: 'Status',
            width: 150,
            dataIndex: 'status',
            render: (text?: string) => (
                <span
                    className={`${
                        text === InvestmentStatus.redeemed || text === InvestmentStatus.repaid
                            ? 'text-[#219653]'
                            : 'text-[#404040]'
                    }`}
                >
                    {text ? text : ''}
                </span>
            ),
        },
    ];

    return (
        <div>
            {!loading && (investments || []).length > 0 && (
                <HSTable
                    rowKey={(record: Investments) => `${record.uuid}_${record.dealUUID}`}
                    columns={columns}
                    data={investments || []}
                    loading={loading}
                    pagination={{ isShow: true }}
                    onRowClick={(i: Investments) => navigate(`${HEADERMENU_PATH.investments}/${i.uuid}`)}
                    tableContainer={'investment_data'}
                    paginationPosition="bottomRight"
                />
            )}
            {!loading && (investments || []).length === 0 && (
                <div>
                    <Empty description={`No Investment Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}
            {loading && (
                <div className="flex justify-center items-center py-4">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default InvestmentTable;
